import {
    message as AntdMessage,
    Spin
} from "antd";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { handleCreateOrganization } from "../../api/auth";
import FormComponent from "../../component/common/FormComponent";
import { signUpFormFields } from "../../data/SignupFormFields";
import NewLogo from "../../assests/images/collab_ai_logo_white.svg";
import "./signup.css"

const SignUp = () => {
    const [loader, setLoader] = useState(false)
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const referrerCode = queryParams.get('referrer_code');

    const handleOk = async (values) => {
        const payload = { ...values, refCode: referrerCode || '' };
        setLoader(true);

        try {
            const { company, message, success } = await handleCreateOrganization(payload);
            if (success) {
                AntdMessage.success(message);
                navigate(`/verify/${company?._id}`);
            } else {
                AntdMessage.error(message);
            }
        } catch (error) {
            AntdMessage.error(error?.message);
        } finally {
            setLoader(false);
        };
    };

    const navigateLogin = () => {   
        navigate("/login");
    }

    return (
        <div className="signup-page">
            <div className="login-page">
                <div className="right-section">
                    <div className="form-signin">

                        <Spin
                            spinning={loader}
                            fullscreen
                            size="large"
                        />

                        <div className="logo-container mb-0">
                            <img src={NewLogo} onClick={navigateLogin} alt="Collab AI Logo" className="logo" />
                        </div>

                        <div className="signUp-field-width">
                            <FormComponent
                                title="SIGN UP"
                                formItems={
                                    signUpFormFields
                                }
                                layout="vertical"
                                handleSubmit={handleOk}
                                className="form mb-4"
                            />
                        </div>

                    </div>
                </div>
            </div>
        </div>

    )
}

export default SignUp
